'use client';

import React, { useState } from 'react';
import HeroCarousel from './HeroCarousel';
import ProductCategories from './ProductCategories';
import HeritageTimeline from './HeritageTimeline';
import EgyptianCottonStory from './EgyptianCottonStory';
import PlatformMetrics from './PlatformMetrics';
import FeaturedManufacturers from './FeaturedManufacturers';
import IndustryCategories from './IndustryCategories';
import SuccessStories from './SuccessStories';
import TrustIndicators from './TrustIndicators';
import CTASection from './CTASection';
import Footer from './Footer';
import SearchModal from './SearchModal';

const HomepageInteractive = () => {
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);

  const handleSearchClick = () => {
    setIsSearchModalOpen(true);
  };

  const handleCloseSearchModal = () => {
    setIsSearchModalOpen(false);
  };

  const handleExploreHeritage = () => {
    // Smooth scroll to timeline section
    const timelineSection = document.getElementById('heritage-timeline');
    if (timelineSection) {
      timelineSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <>
      {/* Egyptian Heritage Hero Carousel */}
      <HeroCarousel />

      {/* Product Categories - غزل، أقمشة، إكسسوارات، ماكينات */}
      <ProductCategories />

      {/* Heritage Timeline Section */}
      <div id="heritage-timeline">
        <HeritageTimeline />
      </div>

      {/* Egyptian Cotton Story */}
      <EgyptianCottonStory />

      {/* Existing Platform Sections */}
      <PlatformMetrics />
      <FeaturedManufacturers />
      <IndustryCategories />
      <SuccessStories />
      <TrustIndicators />
      <CTASection />
      <Footer />
      <SearchModal isOpen={isSearchModalOpen} onClose={handleCloseSearchModal} />
    </>
  );
};

export default HomepageInteractive;